import { render, staticRenderFns } from "./PoiNavbar.vue?vue&type=template&id=3415a7b5&"
import script from "./PoiNavbar.vue?vue&type=script&lang=js&"
export * from "./PoiNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiNavbar.vue"
export default component.exports